import { ApiResponse } from "../interfaces/Api";
import { ClientLinkRequest, ClientLinkRequestStatusType } from "../interfaces/ClientLinkRequests";
import { Delete, Get, Patch, Post } from "./apiHelper";

const clientLinkRoot = "/api/clientLink";

// request client data
export async function requestClientDataAccess({
  requestingResourceCentreId,
  destinationResourceCentreId,
  clientId
}: {
  requestingResourceCentreId: number;
  destinationResourceCentreId: number;
  clientId: number;
}): Promise<ApiResponse<null>> {
  const response = await Post(
    `${clientLinkRoot}`,
    {
      requestingResourceCentreId,
      destinationResourceCentreId,
      clientId
    },
    true
  );

  return response.data as ApiResponse<null>;
}

// get client link requests
export async function getClientLinkRequests({
  rcId,
  status
}: {
  rcId?: number;
  status?: string;
}): Promise<
  ApiResponse<{
    receivedClientLinkRequests: Array<ClientLinkRequest>;
    sentClientLinkRequests: Array<ClientLinkRequest>;
  }>
> {
  const params = new URLSearchParams();

  if (rcId) params.append("rcId", rcId.toString());
  if (status) params.append("status", status);

  const response = await Get(`${clientLinkRoot}?${params.toString()}`, true);

  return response.data as ApiResponse<{
    receivedClientLinkRequests: Array<ClientLinkRequest>;
    sentClientLinkRequests: Array<ClientLinkRequest>;
  }>;
}

// update client link requests
export const patchClientLinkRequest = async (data: {
  requestId: number;
  status?: ClientLinkRequestStatusType;
  hide?: boolean;
  remark?: string;
}): Promise<ApiResponse<ClientLinkRequest>> => {
  const response = await Patch(clientLinkRoot, data, true);
  return response.data as ApiResponse<ClientLinkRequest>;
};

// update client link requests
export const deleteClientLinkRequest = async (data: {
  requestId: number;
}): Promise<ApiResponse<null>> => {
  const response = await Delete(clientLinkRoot, true, data);
  return response.data as ApiResponse<null>;
};
